module.exports = __webpack_public_path__ + "static/media/favorite-full.5ff02a40.svg";